/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} One_Off_Alt_SuffixInputs */

const en_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const id_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ms_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ca_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const cs_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const da_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const de_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const et_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const es_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const fr_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const hr_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const it_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const lv_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const lt_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const hu_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const nl_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const nb_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const pl_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const pt_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ro_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const sk_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const sl_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const fi_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const sv_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const vi_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const tr_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const el_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const bg_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ru_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const sr_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const uk_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ka_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const hi_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const th_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ko_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const zh_tw_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

const ja_one_off_alt_suffix = /** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIX one_off_alt_suffix`)
};

/** @type {(inputs: One_Off_Alt_SuffixInputs) => LocalizedString} */
const zh_one_off_alt_suffix = en_one_off_alt_suffix;

/**
* | output |
* | --- |
* | "FIX one_off_alt_suffix" |
*
* @param {One_Off_Alt_SuffixInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const one_off_alt_suffix = /** @type {((inputs?: One_Off_Alt_SuffixInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<One_Off_Alt_SuffixInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_one_off_alt_suffix(inputs)
	if (locale === "ms") return ms_one_off_alt_suffix(inputs)
	if (locale === "ca") return ca_one_off_alt_suffix(inputs)
	if (locale === "cs") return cs_one_off_alt_suffix(inputs)
	if (locale === "da") return da_one_off_alt_suffix(inputs)
	if (locale === "de") return de_one_off_alt_suffix(inputs)
	if (locale === "et") return et_one_off_alt_suffix(inputs)
	if (locale === "es") return es_one_off_alt_suffix(inputs)
	if (locale === "fr") return fr_one_off_alt_suffix(inputs)
	if (locale === "hr") return hr_one_off_alt_suffix(inputs)
	if (locale === "it") return it_one_off_alt_suffix(inputs)
	if (locale === "lv") return lv_one_off_alt_suffix(inputs)
	if (locale === "lt") return lt_one_off_alt_suffix(inputs)
	if (locale === "hu") return hu_one_off_alt_suffix(inputs)
	if (locale === "nl") return nl_one_off_alt_suffix(inputs)
	if (locale === "nb") return nb_one_off_alt_suffix(inputs)
	if (locale === "pl") return pl_one_off_alt_suffix(inputs)
	if (locale === "pt") return pt_one_off_alt_suffix(inputs)
	if (locale === "ro") return ro_one_off_alt_suffix(inputs)
	if (locale === "sk") return sk_one_off_alt_suffix(inputs)
	if (locale === "sl") return sl_one_off_alt_suffix(inputs)
	if (locale === "fi") return fi_one_off_alt_suffix(inputs)
	if (locale === "sv") return sv_one_off_alt_suffix(inputs)
	if (locale === "vi") return vi_one_off_alt_suffix(inputs)
	if (locale === "tr") return tr_one_off_alt_suffix(inputs)
	if (locale === "el") return el_one_off_alt_suffix(inputs)
	if (locale === "bg") return bg_one_off_alt_suffix(inputs)
	if (locale === "ru") return ru_one_off_alt_suffix(inputs)
	if (locale === "sr") return sr_one_off_alt_suffix(inputs)
	if (locale === "uk") return uk_one_off_alt_suffix(inputs)
	if (locale === "ka") return ka_one_off_alt_suffix(inputs)
	if (locale === "hi") return hi_one_off_alt_suffix(inputs)
	if (locale === "th") return th_one_off_alt_suffix(inputs)
	if (locale === "ko") return ko_one_off_alt_suffix(inputs)
	if (locale === "zh") return zh_one_off_alt_suffix(inputs)
	if (locale === "zh-tw") return zh_tw_one_off_alt_suffix(inputs)
	if (locale === "ja") return ja_one_off_alt_suffix(inputs)
	return en_one_off_alt_suffix(inputs)
});